import { useEffect, useState } from "react";
import { http } from "@/lib/api";
import CourseCard from "@/components/CourseCard";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Seo } from "@/components/Seo";

export default function FormationsPage() {
  const [formations, setFormations] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { http.get("/formations").then((r) => setFormations(r.data)); }, []);
  const filtered = formations.filter((f) =>
    !q || (f.title + f.subtitle + (f.tags || []).join(" ")).toLowerCase().includes(q.toLowerCase())
  );
  return (
    <div className="container-x py-16">
      <Seo title="Formations petite enfance" description="Catalogue de formations professionnelles fondées sur les neurosciences du développement de l'enfant : gestion des crises, langage, jeu, caregiving responsif. Sur devis." />
      <div className="max-w-3xl mb-12">
        <div className="eyebrow mb-3">Formations</div>
        <h1 className="font-display text-4xl sm:text-5xl font-bold text-slate-900 tracking-tight">Le catalogue complet</h1>
        <p className="mt-4 text-slate-600 leading-relaxed text-lg">Des formations conçues par des experts de la petite enfance. Une attestation de participation est délivrée à l'issue de chaque formation. Consultez notre catalogue : choisissez les solutions qui correspondent à votre profil et à votre rythme.</p>
      </div>
      <div className="mb-10 relative max-w-md">
        <Search size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" strokeWidth={1.5} />
        <Input data-testid="formations-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Rechercher une formation…" className="pl-11 h-12 rounded-full" />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {filtered.map((f) => <CourseCard key={f.slug} f={f} />)}
      </div>
      {filtered.length === 0 && <p className="text-center text-slate-500 py-12">Aucune formation trouvée.</p>}
    </div>
  );
}
